module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("COLD CHOICES")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Copyright © 2009 by Larry Bond and Chris Carlson")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A Forge Book")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Published by Tom Doherty Associates, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("175 Fifth Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tor-forge.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tor-forge.com")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Forge"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of Tom Doherty Associates, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bond, Larry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cold choices / Larry Bond.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("       p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A Tom Doherty Associates book.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN-13: 978-0-7653-1875-6")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN-10: 0-7653-1875-X")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("  1. Submarines (Ships)—United States—Fiction. 2. Submarines (Ships)—Russia (Federation)—Fiction. 3. Submarine captains—Fiction. 4. Naval reconnaissance—Fiction. 5. Submarine combat—Fiction. 6. Submarine disasters—Fiction. 7. Search and rescue operations—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("PS3552.O59725C66 2009")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("813'.54—dc22")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("2008050414")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("First Edition: May 2009")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("0   9   8   7   6   5   4   3   2   1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0